<script>
export default {
  props: ['campaign']
}
</script>

<template>
  <div class="facebook-preview">
    <div class="d-flex justify-content-between align-items-center p-2">
      <div class="d-flex align-items-center">
        <img src="@/assets/images/acm-facebook.png" alt="ACM masthead logo" class="facebook-preview__masthead-image" />
        <div class="ml-2 d-flex flex-column">
          <h5 class="font-size-12 text-black mb-1 facebook-preview__masthead-title">{{ campaign.package.masthead.name }}</h5>
          <div class="d-flex align-items-center facebook-preview__sponsored">
            <p class="mb-0 font-size-14">Sponsored</p>
            <i class="bx bx-world ml-1"></i>
          </div>
        </div>
      </div>
      <i class="bx bx-dots-horizontal-rounded font-size-22 mr-2"></i>
    </div>
    <div class="facebook-preview__description-wrapper p-2 d-flex flex-column">
      <p class="facebook-preview__description font-size-16">{{ campaign.shortDescription }}</p>
      <a class="align-self-end font-size-16 text-muted">...see more</a>
    </div>
    <div class="position-relative facebook-preview__image-wrapper">
      <div class="embed-responsive embed-responsive-4by3">
        <div class="embed-responsive-item">
          <img :src="campaign.campaignImages[0].image.url" alt="" class="w-100 h-100" />
        </div>
      </div>
      <div class="facebook-preview__logo-wrapper" :style="{ backgroundColor: campaign.advertiser.backgroundColor }">
        <img :src="campaign.logoImage.url" alt="" class="facebook-preview__logo-image"  />
      </div>
    </div>
    <div class="facebook-preview__headline-wrapper d-flex justify-content-between align-items-center p-2 pt-3">
      <div class="facebook-preview__link-wrapper">
        <p class="font-size-14 mb-1 font-weight-bold facebook-preview__link">ACMADVANTAGE.COM.AU</p>
        <h3 class="font-size-16 mb-1">{{ campaign.digitalHeadline }}</h3>
        <p class="font-size-13 font-weight-bold facebook-preview__link">{{ campaign.advertiser.businessName }}</p>
      </div>
      <button class="facebook-preview__button">{{ campaign.callToActionType.description }}</button>
    </div>
  </div>
</template>